__turbopack_context__.v({
  "className": "inter_278011f6-module__nDhZHa__className",
});
